import {Injectable} from '@angular/core';
import {Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Permissions} from '../helpers/permissions/permissions';
import {CommonFunctions} from '../helpers/core/common.functions';
import {DataSharing} from '../helpers/core/data.sharing';

@Injectable()
export class PermissionsGuard implements CanActivateChild {
    constructor(private router: Router, private cf: CommonFunctions) {
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const pageToken = DataSharing.getPageToken();
        if (pageToken) {
            return true;
        }
        if (route.url.length > 0) {
            if (Permissions.CheckRoute(state.url, route)) {
                return true;
            } else {
                this.cf.ShowToast('You don\'t permissions to access this', 'danger');
                this.router.navigate(['login']);
                return false;
            }
        }
        return true;
    }
}
